export const C240DeviceStatusConstants = {
    UPDATE_SERVER_STATE: "UPDATE_SERVER_STATE",
    UPDATE_DEVICE_STATUS_DATA: "UPDATE_DEVICE_STATUS_DATA",
    UPDATE_QUEUE_STATE: "UPDATE_QUEUE_STATE",
    UPDATE_SCANNER_STATE: "UPDATE_SCANNER_STATE",
    PERSISTED_STATE_CALL_SUCCESS: "PERSISTED_STATE_CALL_SUCCESS",
    PERSISTED_STATE_CALL_FAILED: "PERSISTED_STATE_CALL_FAILED",
    UPDATE_MACHINE_STATUS_BAR: "UPDATE_MACHINE_STATUS_BAR"
}